import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import debounce from 'lodash/debounce';

@Component({
    data() {
        return {
            inputText: null
        };
    }
})
export default class SearchField extends Vue {
    @Prop()
    value: string;

    @Prop()
    label: string;

    @Prop()
    name: string;

    inputText: string;
    debounceSearch = debounce(this.search, 400);

    mounted() {
        this.inputText = this.value || '';
    }

    search() {
        this.$emit('input:debounce', this.inputText);
    }

    @Watch('value')
    onChangeValue(value) {
        this.inputText = value;
    }

    @Watch('inputText')
    onChangeInputText(value) {
        this.$emit('input', value);
    }
}
